import { Component, EventEmitter, Output } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { CmsLink } from '@markant-platform/shared/content/model';
import { CMSLanguageService } from '@markant-platform/shared/data-access';
import { ContentService } from '@markant-platform/shared/content/data-access';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'markant-platform-user-consent-confirmation',
  templateUrl: './user-consent-confirmation.component.html',
  styleUrls: ['./user-consent-confirmation.component.scss'],
})
export class UserConsentConfirmationComponent {
  termsOfUseLink$: Observable<CmsLink>;
  privacyPolicyLink$: Observable<CmsLink>;

  @Output()
  userConsentsConfirmedChanged = new EventEmitter<boolean>();

  formControl = new FormControl<boolean>(false, Validators.required);

  showError = false;

  constructor(
    private readonly cmsLanguageService: CMSLanguageService,
    private readonly contentService: ContentService
  ) {
    this.termsOfUseLink$ = this.cmsLanguageService.activeCMSLanguage$.pipe(
      switchMap(() => {
        return this.contentService.getTermsOfUseLink();
      }),
      map(cmsLinks => cmsLinks[0])
    );
    this.privacyPolicyLink$ = this.cmsLanguageService.activeCMSLanguage$.pipe(
      switchMap(() => {
        return this.contentService.getPrivacyPolicyLink();
      }),
      map(cmsLinks => cmsLinks[0])
    );
  }

  confirmUserConsent(): void {
    if (this.formControl.value !== true) {
      this.showError = true;
      return;
    }
    this.userConsentsConfirmedChanged.emit(true);
    this.showError = false;
  }
}
